// Fluent v9 modal dialogs use tabster's modalizer, which pulls focus back into the open dialog
// ~100 ms after it lands anywhere else — so the guide's search box and Ask input could not be
// typed into while a dialog is open. Marking every guide panel as its own always-accessible
// modalizer lets focus enter it; `isOthersAccessible` hands control straight back when the user
// clicks into the dialog again, and keeps tabster from aria-hiding the page.
export const HELP_TABSTER_ATTRS = {
  'data-tabster': JSON.stringify({
    modalizer: {
      id: 'pct-help-panel',
      isOthersAccessible: true,
      isAlwaysAccessible: true,
    },
  }),
};
